import React, { useEffect, useState } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { BucketList } from './components/buckets/BucketList.cmp';
import { selectBuckets, setBucketList, selectCurrentDate } from './components/buckets/slice/buckets';
import { getSpreadsheetData, clearUserEmailCache } from './components/buckets/slice/functions';
import { useDispatch, useSelector } from 'react-redux';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase-config';
import { signOutUser } from './services/authService';
import './App.css';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ChartsPage from './pages/ChartsPage';
import { APP_BACKGROUND_COLOR } from './components/buckets/constants';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const onLogout = async () => {
    try {
      // Sign out from Firebase
      await signOutUser();

      // Clear the cached user email
      clearUserEmailCache();

      // Clear all cached data
      localStorage.removeItem('buckets');
      localStorage.removeItem('last-state');
      localStorage.removeItem('firebaseIdToken');
      localStorage.removeItem('googleAccessToken');
      localStorage.removeItem('googleRefreshToken');

      // Clear Redux state
      dispatch(setBucketList([]));

      // Clear user from React state
      setUser(null);

      console.log('User logged out successfully');
    } catch (error) {
      console.error('Error during logout:', error);
      // Still clear local data even if Firebase call fails
      clearUserEmailCache();
      localStorage.removeItem('buckets');
      localStorage.removeItem('last-state');
      localStorage.removeItem('firebaseIdToken');
      localStorage.removeItem('googleAccessToken');
      localStorage.removeItem('googleRefreshToken');
      dispatch(setBucketList([]));
      setUser(null);
    }
  }

  // 🔥 Check Firebase authentication state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        console.log('Firebase user authenticated:', firebaseUser.email);
        setUser(firebaseUser);

        try {
          console.log('Loading spreadsheet data...');
          let SSdata = await getSpreadsheetData();
          dispatch(setBucketList(SSdata.values));
          console.log('Spreadsheet data loaded successfully');
        } catch (error) {
          console.error('Error loading spreadsheet data:', error);
        }
      } else {
        console.log('No authenticated user');
        setUser(null);
      }
      setLoading(false);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [dispatch]);

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="App" style={{ backgroundColor: APP_BACKGROUND_COLOR, display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p>Loading...</p>
      </div>
    );
  }


  return (
    <Router>
      <div className="App" style={{ backgroundColor: APP_BACKGROUND_COLOR }}>
        <Routes>
          <Route path="/login" element={!user ? <LoginPage onLogin={setUser} /> : <Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={user ? <DashboardPage user={user} onLogout={onLogout} /> : <Navigate to="/login" />} />
          <Route path="/charts" element={user ? <ChartsPage user={user} /> : <Navigate to="/login" />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
